export enum ERROR_ROUTE_NAMES {
  NOT_FOUND = "404",
  NO_ROLES = "no-roles",
  NO_SSO_EMAIL_MAPPER = "no-sso-email-mapper",
  BAD_GATEWAY_ERROR = "502",
  SERVICE_UNAVAILABLE_ERROR = "503",
  NO_EULA = "no-eula",
}
